<template>
  <!-- 930 仅替换提交与结果流向，表单展示和交互始终复用 entry_sjh。 -->
  <EntrySjh flow-mode="930" />
</template>

<script>
import EntrySjh from '@/views/entryPages/entry_sjh.vue'

export default {
  name: 'Apply930Entry',
  components: {
    EntrySjh,
  },
}
</script>
